module.exports = __webpack_public_path__ + "static/media/Residential_32.a1ade54b.jpg";